import request from '@/utils/request'

// 商家入驻状态接口查询
export function getMercharntStatus(data) {
  return request({
    url: '/portal/pc/getMercharntStatus?type='+data.type+'&username='+data.username,
    method: 'post',
    data:{}
  })
}

export function queryDealerSettledStatus(data) {
  return request({
    url: '/portal/queryDealerSettledStatus',
    method: 'get',
    data:{}
  })
}
// 经销商入驻
export function mercharnt_add(data) {
  return request({
    url: '/portal/mercharnt_add',
    method: 'post',
    data
  })
}

// 线下支付
export function offlinePayment(data) {
  return request({
    url: '/portal/offlinePayment?oid='+data.oid+'&uid='+data.uid+'&paymentVoucher='+data.paymentVoucher,
    method: 'post',
    data:{}
  })
}



// WEBPACK FOOTER //
// ./src/api/dealerSettled.js